import Auth from "@/app/auth/core/router-const";

export default Object.freeze({
  TRAININGS: 'trainings',
  TRAINING_CHAPTER_CATEGORIES: 'training-chapter-categories',
  EXAMS: 'exams',
  USERS: 'users',
  USER_DETAILS: 'user_details',
  USER_DETAILS_EXAMS: 'user_details_exams',
  USER_DETAILS_EXAMS_CBR: 'user_details_exams_CBR',
  PAYMENTS: 'payments',
  PAYMENTS_PLANS: 'payments_plans',
  PAYMENTS_ORDERS: 'payments_orders',
  ...Auth
});
